import { render } from "./loading.container.vue?vue&type=template&id=13ecd032&scoped=true"
import script from "./loading.container.vue?vue&type=script&lang=js"
export * from "./loading.container.vue?vue&type=script&lang=js"

import "./loading.container.vue?vue&type=style&index=0&id=13ecd032&scoped=true&lang=css"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ecd032"]])

export default __exports__